import { createFileRoute, redirect } from '@tanstack/react-router'
import { useSessionStore, waitForHydration } from '@/stores/sessionStore'
import { getDeliveryMode } from '@/lib/deliveryMode'

const DEV_BACKEND_URL = import.meta.env.VITE_DEV_BACKEND_URL

export const Route = createFileRoute('/')(({
  beforeLoad: async () => {
    await waitForHydration()
    const store = useSessionStore.getState()
    let { backendUrl } = store
    const { isAuthenticated, selectedRegister, sessionToken } = store

    // Auto-set backend URL from env in development (always overrides persisted value)
    if (DEV_BACKEND_URL && backendUrl !== DEV_BACKEND_URL) {
      useSessionStore.getState().setBackendUrl(DEV_BACKEND_URL)
      backendUrl = DEV_BACKEND_URL
    }

    if (!backendUrl) {
      throw redirect({ to: '/connect' })
    }

    // No session token -> go to manager/store login
    if (!sessionToken) {
      throw redirect({ to: '/auth' })
    }

    // Session but no register -> go to register selection
    if (!selectedRegister) {
      throw redirect({ to: '/select-register' })
    }

    // Register selected but no clerk logged in -> go to PIN login
    if (!isAuthenticated) {
      throw redirect({ to: '/login' })
    }

    // All good -> the POS, or straight to the driver surface when this device
    // is in delivery mode (a manual per-device preference; see lib/deliveryMode).
    throw redirect({ to: getDeliveryMode() ? '/driver' : '/pos' })
  },
}))
